<template>
  <div class="table-container">
    <table>
      <thead>
        <tr>
          <th></th>
          <th>启航版</th>
          <th>精英版</th>
          <th>至尊版</th>
          <th>定制版</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th class="hard">定制权益</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
        <tr>
          <td>专属定制化功能开发</td>
          <td class="back-w-0"></td>
          <td class="back-w-1"></td>
          <td class="back-w-2"></td>
          <td class="back-c-3"></td>
        </tr>
        <tr>
          <td>自主分配多层级权限</td>
          <td class="back-w-0"></td>
          <td class="back-w-1"></td>
          <td class="back-w-2"></td>
          <td class="back-c-3"></td>
        </tr>
        <tr>
          <td>支持API接口集成方案</td>
          <td class="back-w-0"></td>
          <td class="back-w-1"></td>
          <td class="back-w-2"></td>
          <td class="back-c-3"></td>
        </tr>
        <tr>
          <td>市场活动优先邀请参与</td>
          <td class="back-w-0"></td>
          <td class="back-w-1"></td>
          <td class="back-w-2"></td>
          <td class="back-c-3"></td>
        </tr>
        <tr>
          <td>享受科创全链条服务</td>
          <td class="back-w-0"></td>
          <td class="back-w-1"></td>
          <td class="back-w-2"></td>
          <td class="back-c-3"></td>
        </tr>
        <tr>
          <th class="hard">版本区别</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
        <tr>
          <td>免费专家对接服务</td>
          <td class="back-w-0"></td>
          <td class="back-w-1"></td>
          <td>3次</td>
          <td>10次</td>
        </tr>
        <tr>
          <td>购买权益席位数量</td>
          <td>1-5个</td>
          <td>5-20个</td>
          <td>20-100个</td>
          <td>最多1000个</td>
        </tr>
        <tr>
          <td>购买资源订阅数量</td>
          <td>2-10个</td>
          <td>15-50个</td>
          <td>100-200个</td>
          <td>不限制</td>
        </tr>
        <tr>
          <td>创新赛道项目权益</td>
          <td>1个月</td>
          <td>6个月</td>
          <td>12个月</td>
          <td>12个月</td>
        </tr>
        <tr>
          <th class="hard">基础功能</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
        <tr>
          <td>前沿新闻科研动态</td>
          <td class="back-c-0"></td>
          <td class="back-c-1"></td>
          <td class="back-c-2"></td>
          <td class="back-c-3"></td>
        </tr>
        <tr>
          <td>海量专利论文成果</td>
          <td class="back-c-0"></td>
          <td class="back-c-1"></td>
          <td class="back-c-2"></td>
          <td class="back-c-3"></td>
        </tr>
        <tr>
          <td>技术需求解决方案</td>
          <td class="back-c-0"></td>
          <td class="back-c-1"></td>
          <td class="back-c-2"></td>
          <td class="back-c-3"></td>
        </tr>
        <tr>
          <td>科创资源精准推荐</td>
          <td class="back-c-0"></td>
          <td class="back-c-1"></td>
          <td class="back-c-2"></td>
          <td class="back-c-3"></td>
        </tr>
        <tr>
          <td>科技路演在线观看</td>
          <td class="back-c-0"></td>
          <td class="back-c-1"></td>
          <td class="back-c-2"></td>
          <td class="back-c-3"></td>
        </tr>
        <tr>
          <td>AI智能科创助手</td>
          <td class="back-c-0"></td>
          <td class="back-c-1"></td>
          <td class="back-c-2"></td>
          <td class="back-c-3"></td>
        </tr>
        <tr>
          <td>7*12小时专属管家</td>
          <td class="back-c-0"></td>
          <td class="back-c-1"></td>
          <td class="back-c-2"></td>
          <td class="back-c-3"></td>
        </tr>
        <tr>
          <td>账号权益自主分配</td>
          <td class="back-c-0"></td>
          <td class="back-c-1"></td>
          <td class="back-c-2"></td>
          <td class="back-c-3"></td>
        </tr>
        <tr>
          <td>灵活订阅专家管理</td>
          <td class="back-c-0"></td>
          <td class="back-c-1"></td>
          <td class="back-c-2"></td>
          <td class="back-c-3"></td>
        </tr>
        <tr class="last">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped lang="scss">
.table-container{
  width: 100%;
  background: #FFFFFF;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 20px 11px 12px;
  .last{
    td{
      height: 13px !important;
    }
  }
  td{
    white-space: nowrap;
  }
  .t-title{
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 17px;
    color: #333333;
    line-height: 18px;
    padding-bottom: 15px;
  }
  .back-w-0{
    background-image: url('../../../../assets/images/Tan/vip/w-0.png');
    background-size: 14px 14px;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .back-c-0{
    background-image: url('../../../../assets/images/Tan/vip/c-0.png');
    background-size: 14px 14px;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .back-w-1{
    background-image: url('../../../../assets/images/Tan/vip/w-1.png');
    background-size: 14px 14px;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .back-c-1{
    background-image: url('../../../../assets/images/Tan/vip/c-1.png');
    background-size: 14px 14px;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .back-w-2{
    background-image: url('../../../../assets/images/Tan/vip/w-2.png');
    background-size: 14px 14px;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .back-c-2{
    background-image: url('../../../../assets/images/Tan/vip/c-2.png');
    background-size: 14px 14px;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .back-c-3{
    background-image: url('../../../../assets/images/Tan/vip/c-3.png');
    background-size: 14px 14px;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .type-0{
    width: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    border: 1px solid #E6E6E6;
    border-collapse: separate;	/* 让border-radius有效 */
    border-spacing: 0; /*表格中每个格边距设为0*/
    overflow: hidden;
    thead{
      height: 44px;
      th:nth-child(1){
        background-color: #F4F7FC;
      }
      th:nth-child(2){
        background-color: #EBEBEB;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        line-height: 44px;
        width: 80px;
      }
      th:nth-child(3){
        background-color: #FFD181;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        line-height: 44px;
      }
    }
    tbody{
      .hard{
        font-weight: 600 !important;
        height: 44px !important;
        line-height: 44px !important;
      }
      th:nth-child(1){
        background-color: #FFFFFF;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        height: 36px;
        line-height: 36px;
        text-align: left;
        text-indent: 3em;
      }
      th:nth-child(2){
        background-color: #F9F9F9;
        width: 80px;
      }
      th:nth-child(3){
        background-color: #FEF4E6;
      }
      td:nth-child(1){
        background-color: #FFFFFF;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 36px;
        height: 36px;
        text-indent: 5em;
      }
      td:nth-child(2){
        background-color: #F9F9F9;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 36px;
        height: 36px;
        text-align: center;
        width: 80px;
      }
      td:nth-child(3){
        background-color: #FEF4E6;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #734C42;
        line-height: 36px;
        text-align: center;
      }
    }
  }
  .type-1{
    width: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    border: 1px solid #E6E6E6;
    border-collapse: separate;	/* 让border-radius有效 */
    border-spacing: 0; /*表格中每个格边距设为0*/
    overflow: hidden;
    thead{
      height: 44px;
      th:nth-child(1){
        background-color: #F4F7FC;
      }
      th:nth-child(3){
        background-color: #A2DEFF;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #0067B9;
        line-height: 44px;
      }
      th:nth-child(2){
        width: 90px;
        background-color: #FFD181;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        line-height: 44px;
      }
    }
    tbody{
      .hard{
        font-weight: 600 !important;
        height: 44px !important;
        line-height: 44px !important;
      }
      th:nth-child(1){
        background-color: #FFFFFF;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        height: 36px;
        line-height: 36px;
        text-align: left;
        text-indent: 1em;
      }
      th:nth-child(3){
        background-color: #E3F5FF;
        width: 80px;
      }
      th:nth-child(2){
        background-color: #FEF4E6;
      }
      td:nth-child(1){
        background-color: #FFFFFF;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 36px;
        height: 36px;
        text-indent: 1em;
      }
      td:nth-child(3){
        background-color: #E3F5FF;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #0067B9;
        line-height: 36px;
        height: 36px;
        text-align: center;
        width: 80px;
      }
      td:nth-child(2){
        background-color: #FEF4E6;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #734C42;
        line-height: 36px;
        text-align: center;
      }
    }
  }
  table{
    width: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    border: 1px solid #E6E6E6;
    border-collapse: separate;	/* 让border-radius有效 */
    border-spacing: 0; /*表格中每个格边距设为0*/
    overflow: hidden;
    thead{
      height: 44px;
      th:nth-child(1){
        background-color: #F4F7FC;
        width: 335px;
      }
      th:nth-child(2){
        width: 122px;
        background-color: #EBEBEB;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        line-height: 44px;
        background-image: url('../../../../assets/images/Tan/vip/th-1.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      th:nth-child(3){
        width: 122px;
        background-color: #FFD181;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        line-height: 44px;
        background-image: url('../../../../assets/images/Tan/vip/th-2.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      th:nth-child(4){
        width: 122px;
        background-color: #A2DEFF;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #0067B9;
        line-height: 44px;
        background-image: url('../../../../assets/images/Tan/vip/th-3.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      th:nth-child(5){
        width: 122px;
        background-color: #ABB9FF;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #503BA8;
        line-height: 44px;
        background-image: url('../../../../assets/images/Tan/vip/th-4.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
    }
    tbody{
      .hard{
        font-weight: 600 !important;
        height: 44px !important;
        line-height: 44px !important;
      }
      th:nth-child(1){
        background-color: #FFFFFF;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        height: 36px;
        line-height: 36px;
        text-align: left;
        text-indent: 1em;
        width: 335px;
      }
      th:nth-child(2){
        background-color: #EAF7EF;
        width: 122px;
      }
      th:nth-child(3){
        background-color: #FEF4E6;
        width: 122px;
      }
      th:nth-child(4){
        background-color: #E3F5FF;
        width: 122px;
      }
      th:nth-child(5){
        background-color: #E5E9FF;
        width: 122px;
      }
      td:nth-child(1){
        background-color: #FFFFFF;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 36px;
        height: 36px;
        text-indent: 1em;
        width: 122px;
      }
      td:nth-child(2){
        background-color: #EAF7EF;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 36px;
        height: 36px;
        text-align: center;
        width: 122px;
      }
      td:nth-child(3){
        background-color: #FEF4E6;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #734C42;
        line-height: 36px;
        height: 36px;
        text-align: center;
        width: 122px;
      }
      td:nth-child(4){
        background-color: #E3F5FF;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #0067B9;
        line-height: 36px;
        height: 36px;
        text-align: center;
        width: 122px;
      }
      td:nth-child(5){
        background-color: #E5E9FF;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #503BA8;
        line-height: 36px;
        text-align: center;
        width: 122px;
      }
    }
  }
}
</style>